import React, {MutableRefObject, useEffect, useRef, useState} from 'react';
import {ActivityButton} from './ActivityButton';
import {Form as FormType} from '../types'

type NewEntryFormSubmitButton = {
    form: FormType;
    isActive: boolean;
    disabled: boolean;
    onClick: (saveAsDraft: boolean) => void;
}
export const NewEntryFormSubmitButton: React.FunctionComponent<NewEntryFormSubmitButton> = ({
                                                                                         form,
                                                                                         isActive,
                                                                                         disabled,
                                                                                         onClick,
                                                                                     }): JSX.Element => {
    const submitButtonDropdownRef = useRef(null);
    const [isShowingSubmitButtonMenu, setIsShowingSubmitButtonMenu] = useState<boolean>(false);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (submitButtonDropdownRef?.current && !submitButtonDropdownRef.current?.contains(event.target)) {
                setIsShowingSubmitButtonMenu(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [submitButtonDropdownRef]);

    return (
        <>
            {form.id && form?.button?.type === 'text' &&
                <div className="btn-group"
                     ref={submitButtonDropdownRef}>
                    <ActivityButton
                        className="btn btn-primary"
                        isActive={isActive}
                        disabled={disabled}
                        onClick={() => {
                            setIsShowingSubmitButtonMenu(false);
                            onClick(false);
                        }}
                    >{form?.button?.text || 'Submit'}
                    </ActivityButton>
                    {form.flow_form_save_as_draft_step &&
                        <>
                            <button type="button"
                                    disabled={disabled}
                                    className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                                    onClick={() => {
                                        setIsShowingSubmitButtonMenu(true);
                                    }}
                            >
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            {isShowingSubmitButtonMenu &&
                                <div className="dropdown-menu show">
                                    <a className="dropdown-item"
                                       href="#"
                                       onClick={(e) => {
                                           e.stopPropagation();
                                           e.preventDefault();
                                           onClick(true);
                                           setIsShowingSubmitButtonMenu(false);
                                       }}
                                    >{form.flow_form_save_as_draft_button_text || 'Save As Draft'}</a>
                                </div>
                            }
                        </>
                    }
                </div>
            }

            {form.id && form?.button?.type !== 'text' && form.flow_form_save_as_draft_step &&
                <ActivityButton
                    className="btn btn-primary"
                    isActive={isActive}
                    disabled={disabled}
                    onClick={() => {
                        onClick(true);
                        setIsShowingSubmitButtonMenu(false);
                    }}
                >{form.flow_form_save_as_draft_button_text || 'Save As Draft'}
                </ActivityButton>
            }
        </>
    )
}